import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profile: null,
  preferences: {
    favoriteSports: [],
    notifications: true,
  },
  loading: false,
  error: null,
  location: {
    latitude: null,
    longitude: null,
  },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    fetchProfileStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchProfileSuccess: (state, action) => {
      state.profile = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchProfileFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateProfile: (state, action) => {
      state.profile = { ...state.profile, ...action.payload };
    },
    updatePreferences: (state, action) => {
      state.preferences = { ...state.preferences, ...action.payload };
    },
    clearUserData: (state) => {
      state.profile = null;
      state.preferences = {
        favoriteSports: [],
        notifications: true,
      };
      state.loading = false;
      state.error = null;
      state.location = { latitude: null, longitude: null };
    },
    setLocation: (state, action) => {
      state.location = action.payload;
    },
    clearLocation: (state) => {
      state.location = { latitude: null, longitude: null };
    },
  },
});

export const {
  fetchProfileStart,
  fetchProfileSuccess,
  fetchProfileFailure,
  updateProfile,
  updatePreferences,
  clearUserData,
  setLocation,
  clearLocation,
} = userSlice.actions;
export default userSlice.reducer;
